import { makeStyles, tokens } from '@fluentui/react-components';

export const useConfigureTabPageStyles = makeStyles({
    root: {
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        gap: '10px',
    },
    field: {
        display: 'grid',
        gridRowGap: tokens.spacingVerticalS,
    },
});
